'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutesFromNow;


// WEBPACK FOOTER //
// ./~/sugar-date/number/minutesFromNow.js